import type { SVGProps } from "react";
export default function SvgPlugZap(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-plug-zap-icon lucide-plug-zap"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" />
			<path d="m2 22 3-3" />
			<path d="M7.5 13.5 10 11" />
			<path d="M10.5 16.5 13 14" />
			<path d="m18 3-4 4h6l-4 4" />
		</svg>
	);
}
